<template>
  <v-row dense>
    <v-col cols="12" lg="4" xs="12" sm="4" md="4">
      <v-card tile height="140" flat color="#EEF3F9" class="px-6">
        <v-row class="align-center">
          <v-card-title>
            <span class="primary--text subtitle-1 font-weight-bold">   Visitors in Store</span>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon color="#D5E0EF"
                 :to="{name:PAGE_IDS.STORE_EDIT, params:{store_id:store.id}}">
            <v-icon>settings</v-icon>
          </v-btn>
        </v-row>

        <v-progress-linear rounded :value="visitors_progress"></v-progress-linear>
        <v-card-title class="px-0">
          <span class="primary--text display-1 font-weight-bold">{{1}}</span>
          <v-spacer></v-spacer>
          <v-card-subtitle class="pa-0 primary_light--text">
            {{store.num_persons}} max
          </v-card-subtitle>

        </v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12" lg="4" xs="12" sm="4" md="4">
      <v-card tile height="140" flat color="#EEF3F9" class="px-6">
        <v-card-title>
          <span class="primary--text subtitle-1 font-weight-bold">   Forecast</span>
        </v-card-title>
        <v-card-subtitle class="py-0 text-left primary_light--text">
          Visitors for Today
        </v-card-subtitle>


        <v-card-title class="px-0">
          <!-- <span class="primary--text display-1 font-weight-bold">{{coming_today}}</span> -->
          <span class="primary--text display-1 font-weight-bold">{{2}}</span>


        </v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12" lg="4" xs="12" sm="4" md="4">
      <v-card tile height="140" flat color="#EEF3F9" class="px-6">
        <v-card-title>
          <span class="primary--text subtitle-1 font-weight-bold">   Forecast</span>
        </v-card-title>
        <v-card-subtitle class="py-0 text-left primary_light--text">
          Visitors in 30 min
        </v-card-subtitle>


        <v-card-title class="px-0">
          <!-- <span class="primary--text display-1 font-weight-bold">{{coming_next_30_minutes}}</span> -->
          <span class="primary--text display-1 font-weight-bold">{{1}}</span>


        </v-card-title>
      </v-card>
    </v-col>

  </v-row>
</template>

<script>
  export default {
    name: "DashboardVisitorsForecastCards",
    props: ['store', 'currently_in_store', 'loading', 'coming_next_30_minutes', 'coming_today'],
    data: () => ({
      visitors_progress: 0
    }),

    methods: {
      getVisitorsValue() {
        let max_visitors = this.store.num_persons
        let current_visitors = this.currently_in_store
        this.visitors_progress = 100 * current_visitors / max_visitors
      },
    },
    mounted() {
      this.getVisitorsValue()
    }
  }
</script>

<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';

   .col-12:nth-child(1) {
    .v-card {
      border-radius: 12px 0 0 12px !important;
    }
  }
  .col-12:nth-child(3) {
    .v-card {
      border-radius: 0 12px 12px 0 !important;
    }
  }
 @media #{map-get($display-breakpoints, 'xs-only')} {
   .col-12:nth-child(1) {
    .v-card {
      border-radius: 12px 12px 0 0  !important;
    }
  }
  .col-12:nth-child(3) {
    .v-card {
      border-radius: 0 0 12px 12px !important;
    }
  }
    }


</style>



// WEBPACK FOOTER //
// src/Elements/DashboardVisitorsForecastCards.vue